// Rezervarea temporara (server: App\Support\BookingHold). Cand clienta apasa „Continua” dupa ce a ales
// ora, o TINEM pentru ea cateva minute: pentru ceilalti ora dispare din lista, iar cine apasa deodata pe
// aceeasi ora afla pe loc ca s-a ocupat - nu abia la Finalize, dupa ce si-a completat datele.
//
// Totul e „cel mai bine posibil”: fara rute pe server (bundle nou pe server vechi), fara crypto, la
// eroare de retea sau peste plafon, clienta merge mai departe EXACT ca inainte, iar verificarea de la
// Finalize o protejeaza oricum. Singurul raspuns care o opreste e 409 = ora tocmai a fost luata.
import {newClientRef} from './helpers.js';

const HOLD_TIMEOUT_MS = 6000;
// Serverul tine ora 3 minute de la ultima reinnoire (plafon 10 minute); o bataie pe minut lasa loc
// pentru doua ratate (telefon blocat, tab in fundal) fara sa piarda ora.
const HEARTBEAT_MS = 60000;

let heartbeat = null;

// Rutele se deduc din cea de Finalize (…/{salon}/appointment -> …/appointment/hold), ca la
// …/appointment/recent: nu trebuie atinse nici pagina de booking, nici API-ul widgetului incorporat.
function routeFrom(routes, suffix) {
    const base = routes && routes.storeAppointment;
    if (!base) return null;
    const q = base.indexOf('?');
    return q < 0 ? base + suffix : base.slice(0, q) + suffix + base.slice(q);
}

function post(api, url, data) {
    return new Promise((resolve) => {
        api.post(url, {
            data,
            timeoutMs: HOLD_TIMEOUT_MS,
            success: (r) => resolve({ok: true, data: r}),
            error: (err) => resolve({ok: false, err})
        });
    });
}

export function stopHoldHeartbeat() {
    if (heartbeat) {
        clearInterval(heartbeat);
        heartbeat = null;
    }
}

function startHoldHeartbeat(api, routes, state) {
    stopHoldHeartbeat();
    const url = routeFrom(routes, '/hold/renew');
    if (!url) return;
    heartbeat = setInterval(async () => {
        if (!state.clientRef) { stopHoldHeartbeat(); return; }
        const res = await post(api, url, {clientRef: state.clientRef});
        // expiresIn 0 = tinerea nu mai exista (expirata / rezervare facuta): nu mai insistam.
        // O eroare de retea nu opreste bataia - urmatoarea poate reusi inainte sa expire.
        if (res.ok && !(res.data && res.data.expiresIn > 0)) stopHoldHeartbeat();
    }, HEARTBEAT_MS);
}

/**
 * Incearca sa tina ora aleasa. Rezultat:
 *   {held: true}                 - ora e a ei cateva minute;
 *   {taken: true, message}       - tocmai a luat-o altcineva (409): ramane pe pasul de ore;
 *   {held: false}                - fara tinere, dar merge mai departe ca inainte.
 */
export async function holdSlot(api, routes, state, slot) {
    const url = routeFrom(routes, '/hold');
    if (!url || !api) return {held: false};
    if (!state.clientRef) state.clientRef = newClientRef();
    if (!state.clientRef) return {held: false};

    const res = await post(api, url, {...slot, clientRef: state.clientRef});
    if (res.ok) {
        if (res.data && res.data.held) {
            startHoldHeartbeat(api, routes, state);
            return {held: true};
        }
        return {held: false};
    }
    const err = res.err || {};
    if (err.status === 409) {
        const d = err.data || {};
        const first = d.errors && d.errors.startAt;
        return {taken: true, message: (Array.isArray(first) ? first[0] : first) || d.message || null};
    }
    return {held: false};
}
